import Chart2 from "../Charts/Chart2";
import BarChart from "../hocs/BarChart";
import DailyConsumption from "../hocs/DailyConsumption";
import PlantDemand from "../hocs/PlantDemand";  


export default function SensorTwo(props) { 
  return (  
    <div className="flex flex-col flex-wrap py-2.5  xs:m-0 m-5 my-0 gap-5 "> 
      {/* <div className="flex flex-wrap lg:flex-nowrap gap-4 gap-y-3 items-start w-full justify-center m-0">
        <div className="flex flex-wrap md:flex-nowrap gap-4 mb-5 gap-y-3"> 
          <PlantDemand  theme={props.theme}/>   
          <DailyConsumption theme={props.theme} />
        </div>   
        <div className=" w-full"> 
          <BarChart   theme={props.theme} title='Hourly Consumption' /> 
        </div>  
      </div>  */}
      <Chart2  style={{ width: "100%", height: "500%" ,border:"2px solid white" }} theme={props.theme} title='SOLAR + DG + EB'/> 
    </div>
  )
}